import { useRouter } from "next/navigation";

export const useNavigate = () => {
    const router = useRouter();

    const navigate = (url: string) => {
        try {
            if (typeof window !== "undefined") {
                history.pushState(null, "", url);
            } else {
                router.push(url);
            }
        } catch (error) {
            console.error("Navigation failed:", error);
            window.location.href = url;
        }
    };

    return navigate;
};
